import type { ChangelogEntry } from "../types";

/** CRM fase 3: signalagenter, bedriftsinfo fra Brønnøysund og overvåkning per kunde. */
export const CRM_SIGNALER_2026_10: ChangelogEntry = {
  id: "2026-10-17-crm-signaler",
  date: "2026-10-17",
  title: "Signaler: systemet finner det som skjer hos kundene",
  summary:
    "Agenter leser åpne kilder om kundene og lager kort når noe tyder på at det er et godt tidspunkt å ta kontakt. Du ser kortene i køen, og kan ta ansvar eller si «ikke for meg». Kundekortet har fått bedriftsinfo fra Brønnøysund og en oversikt over hva som overvåkes.",
  sections: [
    {
      heading: "Kundekortet",
      items: [
        {
          title: "Bedriftsinfo fra Brønnøysund",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "Kundekortet viser bransje, antall ansatte, stiftelsesår, roller og omsetning for siste to regnskapsår. Informasjonen oppdateres hver natt. Står det «–», finnes ikke tallet i registeret.",
        },
        {
          title: "Overvåkning per kilde",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "Under «Overvåkning» ser du nettside, Instagram, Facebook og LinkedIn for kunden. Varme og medium kunder følges automatisk. Du kan slå en kilde av eller på selv, og «Tilbakestill til automatisk» går tilbake til å følge kundestatus. Adresser en agent har foreslått må du bekrefte først.",
        },
      ],
    },
    {
      heading: "Køen",
      items: [
        {
          title: "Signalkort i køen",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "Når oppfølgingene dine er ferdige, viser køen signaler: noe har skjedd hos en kunde, med hvorfor nå, forslag til første steg og et mailutkast. «Ta ansvar» (pil høyre) lager en prosess i Outreach og en oppfølging for i dag, og er noen raskere enn deg, går du bare videre. «Ikke for meg» (pil venstre) skjuler signalet for deg.",
        },
        {
          title: "Signaler på kundekortet",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "Kundekortet viser de siste signalene på kunden med status: åpent, tatt av noen, arkivert eller utløpt.",
        },
      ],
    },
    {
      heading: "Agenter og kostnad",
      items: [
        {
          title: "Signalagenter",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "Ti ferdige agenter leter etter blant annet nye stillinger, ny leder, nye produkter, arrangementer, vekst og jubileer. Du kan lage egne med en instruks i vanlig norsk, prøvekjøre dem på tre kunder før du lagrer, og sette et kostnadstak per måned.",
        },
        {
          title: "Kostnader under Drift",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          minRole: "admin",
          body: "Under Innstillinger, Drift, CRM ser administratorer hva agentene har kostet per måned, per agent og per kunde, og kan pause en agent derfra.",
        },
      ],
    },
  ],
};
